import React, { useMemo, useState } from "react";
import TSUtils from "../../utils/helpers/TSUtils";
import KC_Checkbox from "../../designsystem/KC_FormInput/KC_Checkbox";
import { tt } from "../../utils/i18n/i18n";
import { useAccountToDisplaySelector } from "../../redux/actions/user";

interface Props {
  amountToPay: number;
  showMonthlyPayment?: boolean;
  onTermsAccepted?: (accepted: boolean) => void;
}

export default function CGVCheckList(props: Props) {
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const [dpaAccepted, setDPAAccepted] = useState<boolean>(false);
  const { accountToDisplay } = useAccountToDisplaySelector();

  const handleTermsAcceptedChecked = (checked: boolean) => {
    setTermsAccepted(checked);
    if (termsAccepted && dpaAccepted && props.onTermsAccepted) {
      props.onTermsAccepted(checked);
    }
  };

  const handleDPA_AcceptedChecked = (checked: boolean) => {
    setDPAAccepted(checked);
    if (termsAccepted && dpaAccepted && props.onTermsAccepted) {
      props.onTermsAccepted(checked);
    }
  };

  const formattedAmount = useMemo(() => {
    if (!accountToDisplay) {
      return "";
    }
    return TSUtils.formatAmount(
      props.amountToPay,
      accountToDisplay.curSubUnits,
      false,
      accountToDisplay.currency
    );
  }, [accountToDisplay]);

  return (
    <div className="text-primary my-3">
      {!props.showMonthlyPayment && (
        <p className="mb-0">
          {tt("cgv_card_debit_text", { amount: "" })
            .split("{{amount}}")
            .map((part, index, array) => (
              <React.Fragment key={index}>
                {part}
                {index < array.length - 1 && (
                  <span className="text-danger font-weight-bold">
                    {formattedAmount}
                  </span>
                )}
              </React.Fragment>
            ))}
        </p>
      )}

      <div className="form-group mt-4">
        <div className="d-flex">
          <div className="mr-2">
            <KC_Checkbox
              id="cgv-terms-checkbox"
              required
              checked={termsAccepted}
              onChange={() => handleTermsAcceptedChecked(!termsAccepted)}
            />
          </div>
          <div>
            <label htmlFor="terms-checkbox" className="mb-0">
              {tt("cgv_accept_payment_terms_and")}{" "}
              <a
                href={tt("terms_link")}
                target="_blank"
                rel="noopener noreferrer"
                className="font-weight-bold"
              >
                {tt("cgv_terms_and_conditions_link_text")}
              </a>
            </label>
          </div>
        </div>
      </div>

      <div className="form-group mt-4">
        <div className="d-flex">
          <div className="mr-2">
            <KC_Checkbox
              id="dpa-checkbox"
              required
              checked={dpaAccepted}
              onChange={() => handleDPA_AcceptedChecked(!dpaAccepted)}
            />
          </div>
          <div>
            <label htmlFor="terms-checkbox" className="mb-0">
              {tt("dpa_text_1")}{" "}
              <a
                href={tt("dpaURL")}
                target="_blank"
                rel="noopener noreferrer"
                className="font-weight-bold"
              >
                {tt("dpa_text_2")}
              </a>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
